import { VStack } from '@cad-arc';

export function FrPage(props: { children: React.ReactNode }) {
    return (
        <VStack width="100%" height="100vh" style={{ gap: 0, marginLeft: 0, overflow: 'auto' }}>
            {props.children}
        </VStack>
    );
}
